module.exports = __webpack_public_path__ + "static/media/xquartz-token-1600-round.5d0ea8c9.png";